import { createSlice } from '@reduxjs/toolkit';
import {
    fetchPaintings,
    createPainting,
    updatePainting,
    deletePainting,
    moveToSold,
    moveToAvailable,
} from '../actions/paintingsActions';

const initialState = {
    paintings: [],
    loading: false,
    error: null,
    // true после первого успешного GET /paintings — отличает "ещё не загружали"
    // от "в базе действительно 0 картин", чтобы не делать лишний refetch.
    hasLoaded: false,
};

const paintingsSlice = createSlice({
    name: 'paintings',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

            // FETCH
            .addCase(fetchPaintings.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPaintings.fulfilled, (state, action) => {
                state.loading = false;
                state.paintings = action.payload;
                state.hasLoaded = true;
            })
            .addCase(fetchPaintings.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // CREATE — ошибки обрабатываются локально в компоненте через .unwrap();
            // мутация не трогает глобальные loading/error (как delete/move), чтобы
            // падение одной операции не заменяло весь экран списка.
            .addCase(createPainting.fulfilled, (state, action) => {
                state.paintings.push(action.payload);
            })

            // UPDATE — ошибки локально через .unwrap(); глобальные loading/error
            // не трогаем по той же причине.
            .addCase(updatePainting.fulfilled, (state, action) => {
                const updated = action.payload;
                const index = state.paintings.findIndex(p => p._id === updated._id);
                if (index !== -1) {
                    state.paintings[index] = updated;
                }
            })

            .addCase(deletePainting.fulfilled, (state, action) => {
                state.paintings = state.paintings.filter(
                    (painting) => painting._id !== action.meta.arg
                );
            })

            .addCase(moveToSold.fulfilled, (state, action) => {
                const updated = action.payload;
                const index = state.paintings.findIndex(p => p._id === updated._id);
                if (index !== -1) {
                    state.paintings[index] = updated;
                }
            })

            .addCase(moveToAvailable.fulfilled, (state, action) => {
                const updated = action.payload;
                const index = state.paintings.findIndex(p => p._id === updated._id);
                if (index !== -1) {
                    state.paintings[index] = updated;
                }
            });
    },
});

export default paintingsSlice.reducer;